import type { SummaryEmailPayload } from '../../global';
import type { Meeting } from '../../types';

/**
 * Görünüm modelinden e-posta yüküne çeviri.
 *
 * Bilerek dar: e-postaya transkriptin tamamı ya da ham notlar girmiyor —
 * yalnızca özet, kararlar ve aksiyon maddeleri. Gelen kutusunda okunabilir
 * olması gereken şey bu; transkript uygulamada duruyor.
 */
export function meetingToEmailPayload(meeting: Meeting): SummaryEmailPayload {
  return {
    title: meeting.title,
    recordedAtISO: meeting.recordedAtISO,
    durationLabel: meeting.duration,
    participants: meeting.participants.map((p) => p.name).filter(Boolean),
    summary: {
      tldr: meeting.summary.tldr,
      keyPoints: meeting.summary.keyPoints,
      decisions: meeting.summary.decisions,
    },
    actionItems: meeting.actionItems.map((item) => ({
      text: item.text,
      assignee: item.assignee || undefined,
      completed: item.completed,
    })),
  };
}

/** Taslak (henüz kimliği olmayan) toplantılar için aynı çeviri. */
export function draftToEmailPayload(draft: Omit<Meeting, 'id'>): SummaryEmailPayload {
  return meetingToEmailPayload({ ...draft, id: 'draft' });
}
